import React, { useRef, useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import styled from "styled-components";
import CodeIcon from "@mui/icons-material/Code";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import CodeOffIcon from "@mui/icons-material/CodeOff";
import TerminalIcon from "@mui/icons-material/Terminal";
import "@fontsource/raleway";
import { BsGithub, BsFilePdf } from "react-icons/bs";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";

const pages = ["Home", "About", "Skills", "Github", "Projects", "Contact"];
const settings = ["Profile", "Account", "Dashboard", "Logout"];
const id = ["home", "about", "skills", "github", "projects", "contact"];
const classNames = ["home", "about", "skills", "github", "projects", "contact"];
const nav = ["nav", "nav", "nav", "nav", "nav", "nav"];
const OpenPDF = () => {
  const url = `https://drive.google.com/file/d/1Eyk7NdQAlS-swQH5K2KalQIa5KJ6yBPB/view?usp=sharing`;

  window.open(url, "_blank");
};
function DownloadButton({ fileName, fileUrl }) {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      onClick={() => {
        handleDownload();
        OpenPDF();
      }}
      variant="contained"
      className="my-typography-button nav-link resume"
      id="resume-button-1"
      style={{
        backgroundColor: "rgb(255, 255, 255)",
        color: "black",
        margin: "2%",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#04c984")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
      size="medium"
      startIcon={<BsFilePdf />}
      download="Tathagat-Resume.pdf"
    >
      Resume
    </Button>
  );
}

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const { current } = useRef([]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const OpenPDF = () => {
    const url = `https://drive.google.com/file/d/1h-t0I7eCl_I9vcP5huoDnj9UjdIT6k-J/view?usp=sharing`;

    window.open(url, "_blank");
  };

  return (
    <MAIN id="nav-menu" className="nav-link">
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#1b242f",
          borderBottom: "5px solid #04c998",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <TerminalIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />
            <MarqContainer>
              <div className="marquee">
                {" "}
                <Typography
                  variant="h6"
                  noWrap
                  component="a"
                  href="/"
                  sx={{
                    mr: 2,
                    display: { xs: "none", md: "flex" },
                    fontFamily: "monospace",
                    fontWeight: 700,
                    letterSpacing: ".3rem",
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  TATHAGAT
                </Typography>
              </div>
            </MarqContainer>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page, index) => {
                  return (
                    <ScrollLink
                      key={Math.random()}
                      to={id[index]}
                      smooth={true}
                      duration={300}
                    >
                      <MenuItem
                        key={page}
                        onClick={handleCloseNavMenu}
                        className={`${classNames[index]}`}
                      >
                        <Typography textAlign="center">{page}</Typography>
                      </MenuItem>
                    </ScrollLink>
                  );
                })}
              </Menu>
            </Box>

            <MarqContainer>
              <div className="marquee">
                <Typography
                  variant="h5"
                  noWrap
                  component="a"
                  href=""
                  sx={{
                    mr: 2,
                    display: { xs: "flex", md: "none" },
                    flexGrow: 1,
                    fontFamily: "monospace",
                    fontWeight: 700,
                    letterSpacing: ".3rem",
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  TATHAGAT
                </Typography>
              </div>
            </MarqContainer>
            <Box
              sx={{
                flexGrow: 1,
                display: {
                  xs: "none",
                  md: "flex",
                  justifyContent: "space-evenly",
                },
              }}
            >
              {pages.map((page, index) => (
                <Button
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                  className={`${classNames[index]}`}
                >
                  <ScrollLink
                    className={classNames[index]}
                    key={Math.random()}
                    to={id[index]}
                    smooth={true}
                    duration={300}
                  >
                    <span className={`my-typography`}>{page}</span>
                  </ScrollLink>
                </Button>
              ))}
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <DownloadButton
                fileName={"Tathagat-Resume.pdf"}
                fileUrl={"./Tathagat-Resume.pdf"}
              >
                Resume
              </DownloadButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </MAIN>
  );
}
export default ResponsiveAppBar;

const MarqContainer = styled.div`
  overflow: hidden;

  .marquee {
    display: inline-block;
    white-space: nowrap;
    animation: marquee 13s linear infinite;
  }

  .marquee:hover {
    color: #ba106e;
  }
  @keyframes marquee {
    0% {
      transform: translateX(5%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const MAIN = styled.div`
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
  width: 100vw;
  position: sticky;
  top: 0;
  z-index: 5;
  .my-typography {
    color: #ffffff;
    /* other styles */
    transition: color 0.2s ease-in-out; /* smooth transition for color change */
  }

  .my-typography:hover {
    color: #cd146d;
  }
  .my-typography-button {
    color: #030303;
    /* other styles */
    transition: color 0.2s ease-in-out;
  }
  .my-typography-button:hover {
    background-color: red;
  }
`;
